import React from 'react';
import { Anchor, Button, Div, Heading, P } from '@kizi/core-components';
import { IconV2 } from '@kizi/shared-components';

export const CrossSellingBlock = ({
  title,
  subtitle,
  link,
  buttonText,
  icon,
}) => {
  return (
    <Div
      flex={1}
      p={3}
      borderRadius={2}
      display={'flex'}
      justifyContent={'space-between'}
      backgroundColor={'main.0'}
      css={{
        boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.15)',
        background: 'linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(173,210,255,1) 0%, rgba(225,240,255,1) 100%)',
      }}
    >
      <Div
        css={{
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          justifyContent: 'space-between',
        }}
      >
        <Div textAlign={'start'}>
          <Heading as="h3" variant="H3" m={0} lineHeight={'30px'}>
            {title}
          </Heading>
          <P variant="bodyRegular">{subtitle}</P>
        </Div>
        <Button variant="primarySmall" height={'auto'}>
          <Anchor
            href={link}
            target="_blank"
            color="main.0"
            css={{
              fontSize: '14px',
              textDecoration: 'none',
            }}
          >
            {buttonText}
          </Anchor>
        </Button>
      </Div>
      <IconV2 size={32} name={icon} />
    </Div>
  );
};
